<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="form-container">
	<dx-form class="m-3" [(formData)]="item" [showColonAfterLabel]="true" labelLocation="top" [readOnly]="readOnly">
		<dxi-item itemType="tabbed" [tabPanelOptions]="{hoverStateEnabled:false}">
			<dxo-tab-panel-options [deferRendering]="false"></dxo-tab-panel-options>
			<dxi-tab title="Details" [colCount]="2">
				<dxi-item dataField="name"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
				<dxi-item dataField="isActive" [label]="{ text: 'Active' }" editorType="dxCheckBox"></dxi-item>
			</dxi-tab>
			<dxi-tab title="Machines">
				<dxi-item [template]="'machineTemplate'"></dxi-item>
				<div *dxTemplate="let data of 'machineTemplate'" class="row">
					<div *ngFor="let machine of machines" class="col-6 col-sm-4 col-md-6 col-lg-4 col-xl-3 col-xxl-2">
						<div class="machine-tile">
							<div class="tile position-relative pointer" [class.active]="activeMachineIds.indexOf(machine.id) >= 0" (click)="toggleMachine(machine)">
								<span class="position-absolute start-50 translate-middle-x text-center">{{machine.cellNumber}} - {{machine.name}}</span>
							</div>
						</div>
					</div>
				</div>
			</dxi-tab>
		</dxi-item>
	</dx-form>
</div>
